/* eslint-disable react/no-multi-comp */
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { List, Typography } from '@material-ui/core';

import useRouter from 'utils/useRouter';
import { NavigationListItem } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3)
  }
}));

const NavigationList = props => {
  const { pages, ...rest } = props;
  return (
    <List>
      {pages.reduce(
        (items, page) => reduceChildRoutes({ items, page, ...rest }),
        []
      )}
    </List>
  );
};

NavigationList.propTypes = {
  depth: PropTypes.number,
  handleSelect: PropTypes.func,
  pages: PropTypes.array,
};



const reduceChildRoutes = props => {
  const { router, items, page, depth, parent, handleDuplicate, handleOverDrop, handleSelect, handleShare, deleteFolder, onOpenModal, shared } = props;

  const checkFolderOpen = (children = []) => {
    for (const item of children) {
      if (`/repositories/${item.id}` === router.location.pathname) return true
      if (item.children) {
        if (checkFolderOpen(item.children)) return true;
      }
    }
    return false;
  };

  if (page.children) {
    items.push(
      <NavigationListItem
        count={page.children.length}
        deleteFolder={deleteFolder}
        depth={depth}
        handleOverDrop={handleOverDrop}
        key={'folderID' + page.folderID}
        onOpenModal={onOpenModal}
        open={checkFolderOpen(page.children)}
        page={page}
      >
        <NavigationList
          deleteFolder={deleteFolder}
          depth={depth + 1}
          handleDuplicate={handleDuplicate}
          handleOverDrop={handleOverDrop}
          handleSelect={handleSelect}
          handleShare={handleShare}
          onOpenModal={onOpenModal}
          pages={page.children}
          parent={{ ...page, parent }}
          router={router}
          shared={shared}
        />
      </NavigationListItem>
    );
  } else {
    items.push(
      <NavigationListItem
        depth={depth}
        handleDuplicate={handleDuplicate(page.id)}
        handleSelect={handleSelect(parent)}
        handleShare={handleShare(page.id)}
        key={'id' + page.id}
        page={page}
        shared={shared}
      />
    );
  }

  return items;
};

const Navigation = props => {
  const { name, pages, className, component: Component, handleDuplicate, handleShare, handleOverDrop, handleSelect, deleteFolder, onOpenModal, shared, ...rest } = props;

  const classes = useStyles();
  const router = useRouter();

  return (
    <Component
      {...rest}
      className={clsx(classes.root, className)}
    >
      {name && <Typography variant="overline">{name}</Typography>}
      <NavigationList
        deleteFolder={deleteFolder}
        depth={0}
        handleDuplicate={handleDuplicate}
        handleOverDrop={handleOverDrop}
        handleSelect={handleSelect}
        handleShare={handleShare}
        onOpenModal={onOpenModal}
        pages={pages}
        parent={null}
        router={router}
        shared={shared}
      />
    </Component>
  );
};

Navigation.propTypes = {
  className: PropTypes.string,
  component: PropTypes.any,
  deleteFolder: PropTypes.func,
  handleDuplicate: PropTypes.func,
  handleOverDrop: PropTypes.func,
  handleSelect: PropTypes.func,
  handleShare: PropTypes.func,
  name: PropTypes.string,
  onOpenModal: PropTypes.func,
  pages: PropTypes.array.isRequired,
  shared: PropTypes.object
};

Navigation.defaultProps = {
  component: 'nav'
};

export default Navigation;
